import React, { FC } from 'react';

import { useViewType, ViewType } from '@eika/hooks';

import CardsAndDetailsLink from './CardsAndDetailsLink';

import './AccountAddionalLinks.scss';

const AccountAdditionalLinks: FC = () => {
    const viewType = useViewType();

    if (viewType !== ViewType.desktop) {
        return null;
    }
    return <CardsAndDetailsLink />;
};

export default AccountAdditionalLinks;
